const COMMON_PREFIX = "OFFER_BUNDLE";

export const OFFER_BUNDLE = {
    NUDGE_WIDGET: `${COMMON_PREFIX}_NUDGE_WIDGET`,
    HALF_CARD: `${COMMON_PREFIX}_HALF_CARD`,
    HALF_CARD_CTA: `${COMMON_PREFIX}_HALF_CARD_CTA`,
    OPTION_ITEM: `${COMMON_PREFIX}_OPTION_ITEM`,
    BENEFIT_ITEM: `${COMMON_PREFIX}_BENEFIT_ITEM`,
};
